import React from "react";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

/**
 * Single card displaying a word and its score.
 * @param {string} word - The word to display
 * @param {number|null|undefined} score - Score value; shown as 'N/A' when null/undefined
 * @param {string} [borderColor] - Optional left border color (e.g. difficulty color)
 */
export default function WordScoreCard({ word, score, borderColor }) {
    const scoreDisplay =
        score != null && score !== undefined
            ? Number(score).toLocaleString()
            : "N/A";

    return (
        <Paper
            sx={{
                pt: 1,
                pr: 1,
                pb: 1,
                pl: 1,
                height: "100%",
                boxSizing: "border-box",
                ...(borderColor && { borderLeft: `3px solid ${borderColor}` }),
            }}
        >
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
                {word}
            </Typography>
            <Typography variant="body2" color="text.secondary">
                <strong>Score:</strong> {scoreDisplay}
            </Typography>
        </Paper>
    );
}
